import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class GetCareNowFormatService {
  constructor(private translate: TranslateService) {}

  formatWaitTime(waitTime: number): string {
    if (waitTime == null) {
      return this.translate.instant('OPEN_TOMORROW');
    }
    const minutes = Math.floor(waitTime / 60);
    const minuteLabel = this.translate.instant('MINUTES');
    return `${minutes} ${minuteLabel}`;
  }

  formatNextAvailability(availability: string): string {
    if (availability == null || availability.trim() === '') {
      return '';
    }
    const availDate = new Date(availability);
    const today = new Date();
    const availDateMidnight = new Date(availDate);
    availDateMidnight.setHours(0,0,0,0);
    const todayMidnight = new Date(today);
    todayMidnight.setHours(0,0,0,0);

    let dayLabel = '';
    let timeLabel = '';
    if (isNaN(availDate.getTime())) {
      dayLabel = availability;
    } else if (availDateMidnight.getTime() === todayMidnight.getTime()) {
      dayLabel = this.translate.instant('TODAY');
      timeLabel = availDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    } else if (availDateMidnight.getTime() === todayMidnight.getTime() + 86400000) {
      dayLabel = this.translate.instant('TOMORROW');
      timeLabel = availDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    } else {
      var locale = sessionStorage.getItem('locale') || 'en-US';
      if (locale === 'es-US') {
        dayLabel += "el "; 
      }
    
      dayLabel += availDate.toLocaleString(sessionStorage.getItem('locale')?.toString(), { month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true });
      dayLabel = dayLabel.replace("a.m.", "AM");
      dayLabel = dayLabel.replace("p.m.", "PM");
      // timeLabel = availDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    }
    return dayLabel + (timeLabel ? ' ' + timeLabel : '');
  }
}
